<h2 mat-dialog-title class="flex items-center gap-2">
    <span>Credit Costs</span>
</h2>

<mat-dialog-content>
    @let vm = viewState();

    <div class="flex flex-col gap-4">
        @if (vm.loading) {
        <p class="m-0">Loading credit costs...</p>
        } @else if (vm.error) {
        <div class="flex flex-col gap-3">
            <p class="m-0">{{vm.error}}</p>
            <button matButton type="button" (click)="retryLoad()" aria-label="Retry loading credit costs">
                <mat-icon>refresh</mat-icon>Retry
            </button>
        </div>
        } @else if (vm.loaded && vm.creditCosts.length === 0) {
        <p class="m-0">No credit costs are currently available.</p>
        } @else {
        <dl class="m-0 grid">
            <div class="border-outlinegrid grid-cols-[1fr_auto] gap-4 border-0 border-b border-solid pb-2 text-sm font-medium">
                <dt></dt>
                <dd class="m-0 text-right font-bold">Credits</dd>
            </div>
            @for (creditCost of vm.creditCosts; track creditCost.key ?? creditCost.displayName ?? $index) {
            <div class="border-outline grid grid-cols-[minmax(0,1fr)_auto] gap-4 border-0 border-b border-solid py-3 last:border-b-0">
                <dt class="min-w-0">{{creditCost.displayName ?? creditCost.key ?? 'Credit action'}}</dt>
                <dd class="m-0 text-right whitespace-nowrap">{{creditCostLabel(creditCost)}}</dd>
            </div>
            }
        </dl>
        }

        <div>
            <div class="font-bold">Variable Credit Costs</div>
            <p class="m-0">
                Some actions involve variable costs, for example, copying a project, where the total cost would be
                the cost of creating a project and creating each copied cable. Total costs are shown before confirming
                any variable cost action.
            </p>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button matButton mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
